import { useState } from "react";
import { saveSurveyResponse } from "./api";

export default function useSaveResponse({ createUrl, identifier, preview, userUuid }) {
  const [submitting, setSubmitting] = useState(false);
  const [failed, setFailed] = useState(false);

  const save = (question, response) => {
    if(preview) {
      return $.Deferred().resolve().promise();
    }
    return saveSurveyResponse({
      answers: response.answers,
      identifier,
      otherText: response.otherChecked ? response.otherText.trim() : "",
      questionIdentifier: question.identifier,
      score: response.score,
      text: response.text.trim(),
      url: createUrl,
      userUuid
    });
  };

  const submit = (question, response, onSaved) => {
    setSubmitting(true);
    setFailed(false);
    save(question, response)
      .done(onSaved)
      .fail(() => setFailed(true))
      .always(() => setSubmitting(false));
  };

  return { failed, save, setFailed, submit, submitting };
}
